<template>
<div>
    <div class="ui button button-sidebar icon" @click="sidebar = true">
        <i class="icon bars"></i>
    </div>
    <div class="ui sidebar left vertical" :class="{'visible' : sidebar}">
           <router-link :to="{ name: 'home'}">
        <img class="ui medium image logo" src="../assets/images/SVG/zapparoli.svg">
      </router-link>
     <div class="ui secondary vertical menu">
  <router-link v-for="(item,index) in menu" :key="index"  class="ui item" v-if="item.nav == true" :to="item.path ? item.path : '/'" :class="item.classes">{{item.titulo}}
    </router-link>
      </div>
    </div>
    <div class="dimmer" v-if="sidebar" @click="sidebar = false"></div>
    </div>
</template>

<script>
    export default {
    data() {return {
        sidebar: false,
    }},
     props: ['menu'] ,
     watch: {
    $route(to, from) {
      this.sidebar = false
    }
  },

    
    }
</script>

<style lang="sass" scoped>
.sidebar
    padding: 2rem
    background-color: #ffffff
    box-shadow: -2px 0 10px 5px rgba(0,0,0,0.08)
    .logo
        padding: 1rem
    .menu 
        margin-left: auto !important
        .item
            font-size: 1.1rem !important
            font-weight: bold !important
            color: #39565f !important
            border-radius: 25px !important
            &:hover
                background: #00c07f !important
                color: #fff !important
.bm-item-list
    color: #b8b7ad
    margin-left: 10%
    font-size: 20px
.dimmer
    top: 0
    background:rgba(0,0,0,0.8) !important
    position: fixed
    width: 100%
    height: 100%
    z-index: 36
.button-sidebar
    position: fixed
    bottom: 0.7rem
    left: 0.8rem
    z-index: 60
    padding: 0.6rem !important
    font-size: 1.3rem !important
    color: #00c07f !important
    background: rgba(0,0,0,0.08) !important
    
</style>